'use strict';
export var rootCategoryId = '00000000-0000-0000-0000-000000000000';
export var slugify = function (text) {
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-') // Replace spaces with -
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, ''); // Trim - from end of text
};
var CategoryBuilder = /** @class */ (function () {
    function CategoryBuilder() {
        var defaultCategory = {
            id: '01d1d0e8-5245-49d4-8f1b-92bf07e05f86',
            locale: 'en',
            name: 'Category Title',
            parentId: rootCategoryId,
            url: 'http://fullurl.com',
            uri: '/cat-uri',
            position: 0,
            listed: true,
            visible: true,
            data: {
                iconKey: '',
                iconSrc: ''
            }
        };
        this.category = defaultCategory;
    }
    CategoryBuilder.prototype.withName = function (name) {
        this.category.name = name;
        this.category.uri = '/' + slugify(name) + (Math.random() * 999).toFixed(0);
        return this;
    };
    CategoryBuilder.prototype.withChildren = function (children) {
        var _this = this;
        children.forEach(function (cat) {
            cat.parentId = _this.category.id;
        });
        this.category.children = children;
        return this;
    };
    CategoryBuilder.prototype.withId = function (id) {
        this.category.id = id;
        return this;
    };
    CategoryBuilder.prototype.withLang = function (locale) {
        this.category.locale = locale;
        return this;
    };
    CategoryBuilder.prototype.withIconKey = function (iconKey) {
        this.category.data.iconKey = iconKey;
        this.category.data.iconSrc = '';
        return this;
    };
    CategoryBuilder.prototype.withIconSrc = function (iconSrc) {
        this.category.data.iconSrc = iconSrc;
        this.category.data.iconKey = '';
        return this;
    };
    CategoryBuilder.prototype.withVisible = function (visible) {
        this.category.visible = visible;
        return this;
    };
    CategoryBuilder.prototype.withHasPublishedArticleDescendant = function (val) {
        if (val === void 0) { val = true; }
        this.category.hasPublishedArticleDescendant = val;
        return this;
    };
    CategoryBuilder.prototype.build = function () {
        return this.category;
    };
    return CategoryBuilder;
}());
export { CategoryBuilder };
//# sourceMappingURL=category-builder.js.map